import { queryOptions } from '@tanstack/react-query';
import { Role } from '@wavingroup/iot-core/gen/ts/wavin/ignite/v1/user_pb';
import { DeviceModel } from '~/shared/models/device/DeviceModel';
import { getDevice } from '~/services/api/fetchers/getDevice.api';
import { BlazeDeviceQueryKey } from '~/services/queryKeys';
import { createNameFromDeviceId } from '~/shared/models/id-utils';
import { doesUserHaveRequiredRole } from '~/shared/auth/auth-utils';
import { RoleModel } from '~/shared/models/role/RoleModel';
import { queryClient } from '~/shared/api/query-client';

type GetDeviceQueryProps = {
  deviceId: string;
  includeSource?: boolean;
};

export const getDeviceQuery = ({
  deviceId,
  includeSource = true,
}: GetDeviceQueryProps) => {
  const nameFromDeviceId = createNameFromDeviceId(deviceId);

  return queryOptions({
    queryKey: [BlazeDeviceQueryKey.DEVICE, nameFromDeviceId, includeSource],
    queryFn: async () => {
      const device = await getDevice({
        deviceId: nameFromDeviceId,
        includeSource:
          includeSource &&
          (await doesUserHaveRequiredRole(
            queryClient,
            new RoleModel(Role.CONFIG_EDITOR),
          )),
      });
      return new DeviceModel(device);
    },
  });
};
